import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Logger from '../../services/logger';
import sentry from '../../services/sentry';

const { captureException } = sentry();

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    captureException(error, info);
    // Display fallback UI
    this.setState({ hasError: true });
    Logger.error(error, info);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <div>
          <details open>
            <summary>Oops! Something went wrong.</summary>
          </details>
        </div>
      );
    }
    return children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
